<div class="flex-column warranty-inner-replaced">

    <div [class]="styleClass + 'flex-row warranty-parts'">
        <div class="flex-column gap-2 w-100">
            <div class="ui-g-12 p-0 manual-enter" [ngClass]="{'disabled-input-gray': isWarrantySectionDisabled()}">

                <div class="inspection-input">
                    <app-auto-complete
                        placeholder="Search warranty # or manually enter warranty details below for part being replaced"
                        class="mr-2" leftIcon="fal fa-search" id="ac-canned" scrollHeight="270px"
                        listId="ac-canned-list" styleClassInputWrapper="p-6p" [fontSize]="14" theme="border"
                        [floatingLabel]="false" [value]="searchQuery" [listItemFontSize]="14"
                        styleClassList="manual-search" noRecordText="No results found"
                        noRecordIcon="fas fa-search font-14 mr-2" [suggestions]="suggestions" [isLoading]="isLoading"
                        [closeOnSelection]="true"
                        [hasCustomEditableField]="searchQuery && searchQuery.length > 2 ? true : false"
                        [hasEditableField]="searchQuery && searchQuery.length>2 ? true : false"
                        [autoFocus]="focus.search" (appChange)="onSearchQueryChange($event)"
                        (appSelect)="warrantySelect($event)"
                        [disabled]="isWarrantySectionDisabled() || isWarrantySelected" [openDropdownOnGetResult]="true"
                        (appClear)="resetForm()" #autocomplete>
                        <ng-template let-item appTemplate="editable">
                            <div class="flex-start-start pr-1"
                                [ngClass]="searchQuery && searchQuery.length > 2 && !suggestions && 'flex-center-start'">
                                <p class="m-0 font-400 font-14 text-primary" (click)="resetForm(searchQuery)">
                                    <i class="fal fa-plus mr-1"></i>
                                    Manually enter warranty details
                                </p>
                            </div>
                        </ng-template>
                        <ng-template let-item appTemplate="item">
                            <div class="tag-item">
                                <div class="flex-start-center">
                                    <div>
                                        <i class="fal fa-file-alt font-gray font-16 mr-3"></i>
                                    </div>
                                    <div class="flex-between-center width-100p">
                                        <div>
                                            <div class="font-600 font-14 font-black">
                                                Warranty #{{ item?.warrantyNumber }}
                                            </div>
                                            <div class="font-secondary font-14 font-400">
                                                RO# {{ item?.invoiceCode }}
                                                <!-- - {{item.customer}} -->
                                            </div>
                                        </div>

                                        <div class="width-30p">
                                            <div class="text-truncate font-400 font-14 font-black" tooltipPosition="top"
                                                [pTooltip]="item?.partName + ' ' + item?.partNumber">
                                                {{ item?.partName }} - {{ item?.partNumber }}
                                            </div>
                                            <div class="font-secondary font-14 font-400">
                                                Invoice Date: {{ item?.invoiceDate | date: 'MM/dd/yyyy' }}
                                            </div>
                                        </div>
                                    </div>
                                </div>


                            </div>
                        </ng-template>
                    </app-auto-complete>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="flex-column warranty-inner-replaced mt-1" *ngIf="isManuallyEntered">
    <div [class]="styleClass + 'flex-row warranty-parts'">
        <div class="flex-column warranty-parts-section w-100"
            [ngClass]="!isWarrantySectionDisabled() && !isWarrantySelected && 'bg-transparent'">
            <!-- Table header -->
            <div class="flex-row warranty-table-row">
                <span class="ui-g-3 font-14 font-700">Part Name</span>
                <span class="ui-g-2 font-14 font-700">Part #*</span>
                <span class="ui-g-2 font-14 font-700">Warranty
                    #*</span>
                <span class="ui-g-2 font-14 font-700">Repair Order #*</span>
                <span class="ui-g-2 font-14 font-700">Invoice Date*</span>
            </div>
            <!-- Table rows -->
            <div class="flex-row warranty-table-row" *ngFor="let partHistory of partWarrantiesHistory">
                <span class="ui-g-3 font-14 font-400 text-truncate">
                    <app-input id="part-number" type="text" placeholder="Part Name" theme="border"
                        [disabled]="isWarrantySectionDisabled() || isWarrantySelected" [fontSize]="14" name="name"
                        [autoFocus]="false" [value]="partHistory?.partName" [maxLength]="50"
                        (appChange)="handleWarrantyFieldChange('partName', $event)" (appFocus)="error.partName='';">
                    </app-input>
                </span>

                <span class="ui-g-2 font-14 font-400 text-truncate">
                    <app-input id="part-number" type="text" placeholder="Part #" theme="border"
                        [isInvalid]="error?.partNumber && !partHistory?.partNumber"
                        [errorMessage]="error?.partNumber && !partHistory?.partNumber"
                        [disabled]="isWarrantySectionDisabled() || isDisabledPartNumber" [fontSize]="14" name="name"
                        [autoFocus]="false" [value]="partHistory?.partNumber" [maxLength]="50"
                        (appFocus)="error.partNumber='';" (appChange)="handleWarrantyFieldChange('partNumber', $event)">
                    </app-input>
                </span>

                <span class="ui-g-2 font-14 font-400 text-truncate">
                    <app-input id="part-warrantyNumber" type="text" placeholder="Warranty #" theme="border"
                        [isInvalid]="error?.warrantyNumber && !partHistory?.warrantyNumber"
                        [errorMessage]="error?.warrantyNumber && !partHistory?.warrantyNumber"
                        [disabled]="isWarrantySectionDisabled() || isWarrantySelected" [fontSize]="14" name="name"
                        [autoFocus]="false" [value]="partHistory?.warrantyNumber" [maxLength]="50"
                        (appChange)="handleWarrantyFieldChange('warrantyNumber', $event)"
                        (appFocus)="error.warrantyNumber='';">
                    </app-input>
                </span>

                <span class="ui-g-2 font-14 font-400 text-truncate">
                    <app-input id="part-number" type="text" placeholder="Repair Order #" theme="border"
                        [isInvalid]="error?.invoiceCode && !partHistory?.invoiceCode"
                        [errorMessage]="error?.invoiceCode && !partHistory?.invoiceCode"
                        [disabled]="isWarrantySectionDisabled() || isWarrantySelected" [fontSize]="14" name="name"
                        [autoFocus]="false" [value]="partHistory?.invoiceCode" [maxLength]="50"
                        (appChange)="handleWarrantyFieldChange('invoiceCode', $event)"
                        (appFocus)="error.invoiceCode='';">
                    </app-input>
                </span>

                <span class="ui-g-3 font-14 font-400 text-truncate">

                    <div class="calendar-input flex-between-center manual-warranty-date pointer" [ngClass]="{
                        'disable-calendar disabled-with-default': (isWarrantySectionDisabled() || isWarrantySelected),
                        'invalid-error': error.invoiceDate && !partHistory.invoiceDate,
                      }" style="border: 1px solid var(--secondary-200);
                        border-radius: 3px;" *ngIf="!isWarrantySelected">
                        <p-calendar id="payment-date" placeholder="MM/DD/YYYY" appendTo="body" [baseZIndex]="1000"
                            [(ngModel)]="partHistory.invoiceDate" [readonlyInput]="false"
                            [panelStyleClass]="openFrom !== 'merge-prompt' && 'manual-warranty-datepicker'"
                            dateFormat="mm/dd/yy" (onSelect)="onDateChange($event)" #paymentDateTimeEl>
                        </p-calendar>

                        <i class="fal fa-calendar mr-2" (click)="
                                           paymentDateTimeEl.showOverlay()"></i>
                    </div>

                    <div *ngIf="isWarrantySelected" class="d-flex">
                        <div class="mr-3">
                            <app-input id="part-number" type="text" placeholder="Repair Order #" theme="border"
                                [fontSize]="14" name="name" [value]="partHistory?.invoiceDate | date: 'MM/dd/yyyy'" [disabled]="true">
                            </app-input>
                        </div>

                        <button class="btn btn-delete" [ngClass]=" openFrom === 'merge-prompt' && 'pr-0'"
                            (click)="resetForm()" [disabled]="isWarrantySectionDisabled()">
                            <i class="fal fa-trash mr-3"></i>
                            <span class="font-700 font-14" *ngIf="openFrom !== 'merge-prompt'">Delete</span>
                        </button>

                    </div>
                </span>

            </div>

        </div>
    </div>
</div>
